import type { DividerContent } from '@mawkaa/types';
import { cn } from '@mawkaa/ui';

interface DividerBlockProps {
  content: DividerContent;
}

export function DividerBlock({ content }: DividerBlockProps) {
  const { style = 'line', color, width = 'medium' } = content;

  const widthClasses = {
    full: 'w-full',
    medium: 'w-1/2',
    small: 'w-1/4',
  };

  const styleClasses = {
    line: 'border-t',
    dashed: 'border-t border-dashed',
    dotted: 'border-t border-dotted',
    gradient: 'h-px bg-gradient-to-r from-transparent via-gray-300 to-transparent',
  };

  return (
    <div className="px-4 py-2 flex justify-center">
      <hr
        className={cn(widthClasses[width], styleClasses[style])}
        style={{ borderColor: color }}
      />
    </div>
  );
}
